import { useLocation } from "@tanstack/react-router";

import { useIsPostModalOverlay } from "@/react/hooks/usePostModalParams";
import { withLeadingHashPrefix } from "@/react/utils/router/locationHash";

import { COMMENT_ANCHOR_PREFIX } from "./constants";

export const useCommentFromLocationHash = () => {
  const isPostModalOverlay = useIsPostModalOverlay();
  const maskedHash = useLocation({
    select: location => location.maskedLocation?.hash,
  });
  const unmaskedHash = useLocation({
    select: location => location.hash,
  });
  const hash = withLeadingHashPrefix(
    isPostModalOverlay ? maskedHash : unmaskedHash,
  );
  const commentIdFromHash = hash.split(COMMENT_ANCHOR_PREFIX)[1];
  const commentId =
    (commentIdFromHash && Number.parseInt(commentIdFromHash, 10)) || null;

  return { commentId };
};
